import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, HostListener } from '@angular/core';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TrackerService {
  public httpPostOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{}
  };

  public trackerCounter = 0;
  constructor(private http:HttpClient, private apiRequest: ApiRequestService) { 
    // window.focus()
  }

  public interval: number = 0;
  public timer;
  startTimer(){
    this.stopTimer();
    this.timer = setInterval(() => {
      this.interval++;
      // console.log("focused in service ", this.interval)
    },1000);
  }
  stopTimer(){
    clearInterval(this.timer);
    // console.log("blure in service", this.interval)
  }
  


  submitTracker(data){
    // {"uuid":<file_uuid/studyUuid>,"file_type":"repo"/"dynaview","misc":<json for addition data like time>,"action":"view"/"expand"}
    // "Response" : if Success : {status:1,message:"audit entry created"}
    // if Failed : {status:0,errorMessage:"msg",debug:err}
    this.postTracker(data).subscribe(result =>{
      result;
    })
  }

  postTracker(body){
    return this.apiRequest.request('POST','/addAuditTrail',body);
    // return this.http.post(environment.apiUrl + '/addAuditTrail', body, this.httpPostOptions);
  }

  postTrackerPromise(body){
    return this.apiRequest.request('POST','/addAuditTrail',body).toPromise();
    // return this.http.post(environment.apiUrl + '/addAuditTrail', body, this.httpPostOptions).toPromise();
  }
}
